import { takeLatest, call, put } from 'redux-saga/effects';
import axios from 'axios';
import { getDroneCategorySuccess, getDroneCategoryFailure } from '../slice/droneCategorySlice';
const url =process.env.REACT_APP_API_URL;
function* fetchDroneCategory(action) {
  try {
    const response = yield call(() => axios.get(`${url}/getCategory?page=${action.payload}`));
    yield put(getDroneCategorySuccess(response.data.data.categories));
  } catch (error) {
    yield put(getDroneCategoryFailure(error.message));
  }
}

export function* watchGetDroneCategory() {
  yield takeLatest('droneCategory/getDroneCategory', fetchDroneCategory);
}
